module.exports = __webpack_public_path__ + "fonts/text-bold.d17e2334.woff";